@if (facetList$ | async; as facetList) {
  @if (model$ | async; as model) {
    <div class="product-grid-results">
      {{ model.pagination.totalResults }}
      {{ (model.pagination.totalResults > 1 ? 'productList.numberProducts' : 'productList.numberProduct') | cxTranslate }}
    </div>
  }
  <div class="d-flex active-facets">
    @for (facet of facetList?.activeFacets; track facet) {
      <a
        routerLink="./"
        [queryParams]="getLinkParams(facet)"
        [cxFocus]="getFocusKey(facetList, facet)"
        >
        <span>{{ facet.facetValueName }}</span>
        <cx-icon aria-hidden="true" [type]="closeIcon"></cx-icon>
      </a>
    }
  </div>
}
